import React from 'react'

const Recruiting = () => {
  return (
     <section id='values'>
      <div className="s-60"></div>
      <div className="container brd-white bg-white bottom-none p-5">
        <div className="s-20"></div>
        <h2 className="title-intro c-dark">Values</h2>
        <div className="s-40"></div>
        <div className="row">
          <div className="col-lg-4">
            <p className="stroke c-medium">1</p>
            <h4 className="title my-4 c-medium w-80">Fast Delivery</h4>
            <div className="s-10"></div>
            <p className='c-medium w-90'>From idea to first release in weeks.</p>
          </div>
          <div className="col-lg-4">
            <p className="stroke c-medium">2</p>
            <h4 className="title my-4 c-medium w-80">Secure by Design</h4>
            <div className="s-10"></div>
            <p className='c-medium w-90'>Security best practices built in from day one.</p>
          </div>
          <div className="col-lg-4">
            <p className="stroke c-medium">3</p>
            <h4 className="title my-4 c-medium w-80">Built to Scale</h4>
            <div className="s-10"></div>
            <p className='c-medium w-90'>Ready for growth in users, data, and traffic.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export {Recruiting}
